import { getOffset } from '@opten/dom/get-offset';
import { parseCssUnit } from '@opten/number/parse-css-unit';
import { getStyles } from '@opten/dom/get-styles';
import { getCss } from '@opten/dom/get-css';

export class CrossSellingBoxData {
	index: number;
	height: number;
	currentHeight: number;
	maxTopMarginMove: number;
	stickPosition: number;
	state: {
		isFixed: boolean;
		isExpanded: boolean;
	};
	body: {
		height: number;
		currentHeight: number;
	};
}

export class CrossSellingBox {
	bodyElement: HTMLElement;
	toggleElement: HTMLElement;
	data: CrossSellingBoxData;

	constructor(
		public element: HTMLElement,
		selectorBody: string,
		selectorToggle: string,
		gutterTop: number,
		index: number,
		before?: CrossSellingBox
	) {
		this.bodyElement = this.element.getElementsByClassName(
			selectorBody
		)[0] as HTMLElement;

		this.toggleElement = this.element.getElementsByClassName(
			selectorToggle
		)[0] as HTMLElement;

		this._setData(gutterTop, index, before);
	}

	private _setData(gutterTop: number, index: number, before?: CrossSellingBox) {
		this.bodyElement.style.height = 'auto';

		const styles = getStyles(this.element); // cache

		let stickPosition;
		let maxTopMarginMove = 0;
		let borderWidth = 0;
		if (!before) {
			const offset = getOffset(this.element);
			stickPosition = offset.top() - gutterTop;
		} else {
			// Firefox fix: border-bottom-width instead of border-width
			borderWidth = parseCssUnit(
				getCss(this.element, 'border-bottom-width', styles)
			);

			stickPosition =
				before.data.stickPosition +
				before.data.body.height +
				before.data.maxTopMarginMove +
				borderWidth;

			const marginBottom = parseCssUnit(
				getCss(this.element, 'margin-bottom', styles)
			);

			maxTopMarginMove = Math.round(marginBottom + borderWidth);
		}

		this.data = {
			index,
			height: this.element.offsetHeight,
			currentHeight: this.element.offsetHeight,
			maxTopMarginMove,
			stickPosition,
			state: {
				isFixed: false,
				isExpanded: false,
			},
			body: {
				height: this.bodyElement.offsetHeight,
				currentHeight: this.bodyElement.offsetHeight,
			},
		};
	}
}
